import { useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import React, { useContext } from 'react';

import { MenuContext } from '../MenuContext';
import { useHeaderMenuLargeStyles } from '../menuStyles/menuStyles';

const MenuDivider: React.FC = () => {
  const theme = useTheme();
  const menuContext = useContext(MenuContext);
  const styles = useHeaderMenuLargeStyles(theme, menuContext.selectedTheme);

  return (
    <Divider
      component="div"
      className={styles.divider}
      orientation="vertical"
      variant="middle"
      flexItem
    />
  );
};

export default MenuDivider;
